import { ReactNode } from "react";

const replaceJSX = (
  template: string,
  findArray: string[],
  replaceArray: ReactNode[],
): ReactNode[] => {
  let result: ReactNode[] = [template];

  findArray.forEach((find, index) => {
    const replace = replaceArray[index];
    result = result.flatMap((item) =>
      typeof item === "string"
        ? item
            .split(find)
            .flatMap((part, i, arr) =>
              i < arr.length - 1 ? [part, replace] : [part],
            )
        : [item],
    );
  });

  return result;
};

export default replaceJSX;
